import Vue from 'vue';
import VueRouter from 'vue-router';
import Indicator from '../components/Indicator';
import Store from '@/utils/Store';
import { ROUTE_NAMES } from '@/utils/routeNames.js';
import { initWxJssdk } from '@/utils/wechatJssdk.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: ROUTE_NAMES.home,
    component: () => import('@/views/home'),
    meta: {
      title: '形白定制',
      keepAlive: true
    }
  },
  {
    path: '/createCard',
    name: ROUTE_NAMES.createCard,
    component: () => import('@/views/createCard'),
    meta: {
      title: '形白定制',
      keepAlive: true
    }
  },
  {
    path: '/selectCard',
    name: ROUTE_NAMES.selectCard,
    component: () => import('@/views/selectCard'),
    meta: {
      title: '选择尺寸规格',
      keepAlive: true
    }
  },
  {
    path: '/customCard',
    name: ROUTE_NAMES.customCard,
    component: () => import('@/views/customCard'),
    meta: {
      title: '自定义规格'
    }
  },
  {
    path: '/cardDetail',
    name: ROUTE_NAMES.cardDetail,
    component: () => import('@/views/cardDetail'),
    meta: {
      requireWxJssdk: true,
      title: ''
    }
  },
  {
    path: '/orderCheck',
    name: ROUTE_NAMES.orderCheck,
    component: () => import('@/views/orderCheck'),
    meta: {
      title: '购买并校验订单'
    }
  },
  {
    path: '/saveImage',
    name: ROUTE_NAMES.saveImage,
    component: () => import('@/views/saveImage'),
    meta: {
      title: ''
    }
  },
  {
    path: '/orderDetail',
    name: ROUTE_NAMES.orderDetail,
    component: () => import('@/views/orderDetail'),
    meta: {
      requireWxJssdk: true,
      title: '订单详情'
    }
  },
  {
    path: '/skuDetail',
    name: ROUTE_NAMES.skuDetail,
    component: () => import('@/views/skuDetail'),
    meta: {
      requireWxJssdk: true,
      title: '证件照冲印'
    }
  },
  {
    path: '/test',
    name: ROUTE_NAMES.test,
    component: () => import('@/views/test'),
    meta: {
      title: ''
    }
  },
  {
    path: '/addPhoto',
    name: ROUTE_NAMES.addPhoto,
    component: () => import('@/views/addPhoto'),
    meta: {
      title: '添加照片',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/editLifePhoto',
    name: ROUTE_NAMES.editLifePhoto,
    component: () => import('@/views/editLifePhoto'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/editPld',
    name: ROUTE_NAMES.editPld,
    component: () => import('@/views/editPld'),
    meta: {
      title: '编辑',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/editNameSticker',
    name: ROUTE_NAMES.editNameSticker,
    component: () => import('@/views/editNameSticker'),
    meta: {
      title: '编辑',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/selectTemplate',
    name: ROUTE_NAMES.selectTemplate,
    component: () => import('@/views/selectTemplate'),
    meta: {
      title: '选择模板',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/chooseTemplate',
    name: ROUTE_NAMES.chooseTemplate,
    component: () => import('@/views/templateMutiImage/chooseTemplate.vue'),
    meta: {
      title: '选择款式',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/selectLifeTemplate',
    name: ROUTE_NAMES.selectLifeTemplate,
    component: () => import('@/views/selectLifeTemplate'),
    meta: {
      title: '选择模板',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/editPb',
    name: ROUTE_NAMES.editPb,
    component: () => import('@/views/editPb'),
    meta: {
      title: '编辑',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/editLifePb',
    name: ROUTE_NAMES.editLifePb,
    component: () => import('@/views/editLifePb'),
    meta: {
      title: '编辑',
      requireWxJssdk: true,
      keepAlive: true
    }
  },
  {
    path: '/fullscreen',
    name: ROUTE_NAMES.fullscreen,
    component: () => import('@/views/fullscreen'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  {
    path: '/pbDetail',
    name: ROUTE_NAMES.pbDetail,
    component: () => import('@/views/pbDetail'),
    meta: {
      title: '拼版冲印'
    }
  },
  {
    path: '/finish',
    name: ROUTE_NAMES.finish,
    component: () => import('@/views/finish'),
    meta: {
      title: '上传成功'
    }
  },
  {
    path: '/editPaster',
    name: ROUTE_NAMES.editPaster,
    component: () => import('@/views/editPaster'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/edit',
    name: ROUTE_NAMES.edit,
    component: () => import('@/views/edit'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/stickerEdit',
    name: ROUTE_NAMES.stickerEdit,
    component: () => import('@/views/sticker/index.vue'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/stickerEditBg',
    name: ROUTE_NAMES.stickerEditBg,
    component: () => import('@/views/sticker/stickerEditBg.vue'),
    meta: {
      title: '模板'
    }
  },
  {
    path: '/stickerRetouch',
    name: ROUTE_NAMES.stickerRetouch,
    component: () => import('@/views/sticker/stickerRetouch.vue'),
    meta: {
      title: '抠图'
    }
  },
  {
    /* 贴纸 阵列排版抠图 */ path: '/stickerRetouchFromAdd',
    name: ROUTE_NAMES.stickerRetouchFromAdd,
    component: () => import('@/views/sticker/stickerRetouchFromAdd.vue'),
    meta: {
      title: '抠图'
    }
  },
  {
    /* 贴纸 阵列排版 */ path: '/stickerLayout',
    name: ROUTE_NAMES.stickerLayout,
    component: () => import('@/views/sticker/layout.vue'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/selectImage',
    name: ROUTE_NAMES.selectImage,
    component: () => import('@/views/selectImage'),
    meta: {
      requireWxJssdk: true,
      title: '编辑照片顺序'
    }
  },
  {
    path: '/editPhotoRoll',
    name: ROUTE_NAMES.editPhotoRoll,
    component: () => import('@/views/editPhotoRoll'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/photoRollTemplate',
    name: ROUTE_NAMES.photoRollTemplate,
    component: () => import('@/views/photoRollTemplate'),
    meta: {
      title: '选择模板'
    }
  },
  {
    path: '/photoRollDetail',
    name: ROUTE_NAMES.photoRollDetail,
    component: () => import('@/views/photoRollDetail'),
    meta: {
      title: '选择模板'
    }
  },
  {
    path: '/retouch',
    name: ROUTE_NAMES.retouch,
    component: () => import('@/views/retouch'),
    meta: {
      title: '手动抠图'
    }
  },
  {
    path: '/customSize',
    name: ROUTE_NAMES.customSize,
    component: () => import('@/views/customSize'),
    meta: {
      title: '自定义规格'
    }
  },
  {
    path: '/editCustomSize',
    name: ROUTE_NAMES.editCustomSize,
    component: () => import('@/views/editCustomSize'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/changeHole',
    name: ROUTE_NAMES.changeHole,
    component: () => import('@/views/changeHole'),
    meta: {
      title: '改孔位'
    }
  },
  {
    path: '/changeKeyHole',
    name: ROUTE_NAMES.changeKeyHole,
    component: () => import('@/views/changeKeyHole'),
    meta: {
      title: '改孔位'
    }
  },
  {
    path: '/changeSocket',
    name: ROUTE_NAMES.changeSocket,
    component: () => import('@/views/changeSocket'),
    meta: {
      title: '移动插口'
    }
  },
  {
    path: '/multipleComponent',
    name: ROUTE_NAMES.multipleComponent,
    component: () => import('@/views/multipleComponent'),
    meta: {
      title: '多部件'
    }
  },
  {
    path: '/editImage',
    name: ROUTE_NAMES.editImage,
    component: () => import('@/views/editImage'),
    meta: {
      title: '编辑图片'
    }
  },
  {
    path: '/editImageNew',
    name: ROUTE_NAMES.editImageNew,
    component: () => import('@/views/editImageNew'),
    meta: {
      title: '编辑图片'
    }
  },
  {
    path: '/background',
    name: ROUTE_NAMES.background,
    component: () => import('@/views/background'),
    meta: {
      title: '背景页面'
    }
  },
  {
    path: '/editBackground',
    name: ROUTE_NAMES.editBackground,
    component: () => import('@/views/editBackground'),
    meta: {
      title: '编辑背景'
    }
  },
  {
    path: '/editWhiteInk',
    name: ROUTE_NAMES.editWhiteInk,
    component: () => import('@/views/editWhiteInk'),
    meta: {
      title: '编辑白墨'
    }
  },
  {
    path: '/editWhiteInkNew',
    name: ROUTE_NAMES.editWhiteInkNew,
    component: () => import('@/views/editWhiteInkNew'),
    meta: {
      title: '编辑白墨'
    }
  },
  {
    path: '/reversePrimerLayer',
    name: ROUTE_NAMES.reversePrimerLayer,
    component: () => import('@/views/reversePrimerLayer'),
    meta: {
      title: '逆向层'
    }
  },
  {
    path: '/editScopeUv',
    name: ROUTE_NAMES.editScopeUv,
    component: () => import('@/views/editScopeUv'),
    meta: {
      title: '局部UV'
    }
  },
  {
    path: '/stamping',
    name: ROUTE_NAMES.stamping,
    component: () => import('@/views/stamping'),
    meta: {
      title: '烫色'
    }
  },
  {
    path: '/previewColorPaper',
    name: ROUTE_NAMES.previewColorPaper,
    component: () => import('@/views/previewColorPaper'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/previewColorPaperNew',
    name: ROUTE_NAMES.previewColorPaperNew,
    component: () => import('@/views/previewColorPaperNew'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/previewLaminatedColorPaper',
    name: ROUTE_NAMES.previewLaminatedColorPaper,
    component: () => import('@/views/previewLaminatedColorPaper'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/previewReverseLayer',
    name: ROUTE_NAMES.previewReverseLayer,
    component: () => import('@/views/previewReverseLayer'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/previewPoster',
    name: ROUTE_NAMES.previewPoster,
    component: () => import('@/views/previewPoster'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/editColorPaper',
    name: ROUTE_NAMES.editColorPaper,
    component: () => import('@/views/editColorPaper'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/',
    name: ROUTE_NAMES.debug,
    component: () => import('@/views/debug'),
    meta: {
      title: '形白定制'
    }
  },
  {
    path: '/demo',
    name: ROUTE_NAMES.demo,
    component: () => import('@/views/demo'),
    meta: {
      title: 'demo'
    }
  },
  {
    path: '/templateMutiImageSelect',
    name: ROUTE_NAMES.templateMutiImageSelect,
    component: () => import('@/views/templateMutiImage/selectTemplate.vue'),
    meta: {
      title: '选择蒙版'
    }
  },
  {
    path: '/templateMutiImageEdit',
    name: ROUTE_NAMES.templateMutiImageEdit,
    component: () => import('@/views/templateMutiImage/edit.vue'),
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/templateMutiImageEditBackground',
    name: ROUTE_NAMES.templateMutiImageEditBackground,
    component: () => import('@/views/templateMutiImage/editBackground.vue'),
    meta: {
      title: '选择背景'
    }
  },
  {
    path: '/changeOutline',
    name: ROUTE_NAMES.changeOutline,
    component: () => import('@/views/changeOutline'),
    meta: {
      title: '描边'
    }
  },
  {
    path: '/demo/editTextLayer',
    name: 'editTextLayer',
    component: () => import('@/views/demo/editTextLayer'),
    meta: {
      title: '文字编辑'
    }
  }
];

const router = new VueRouter({
  mode: 'hash', // history
  routes
});

import * as mwx from '@/utils/common.js';

// 设置一个存储上次导航时间的变量
let lastGoBackTime = 0;
// 设置一个最短允许的间隔（例如500毫秒）
const minNavigationInterval = 500; // 单位为毫秒

/** 首次进入先保存小程序传入的 wxData，再启动 JSSDK/鉴权请求，避免首批请求读取旧缓存。 */
router.beforeEach((to, from, next) => {
  if (!from.matched.length && to.query.wxData) {
    // 先解析一次wxData，避免使用旧token
    mwx.parseWxDataAndLoadJsSdk(to.query.wxData);
  }
  if (to.matched.some((r) => r.meta.requireWxJssdk)) {
    initWxJssdk();
  }
  if (to.query.shopId) {
    Store.set('shopId', to.query.shopId);
  }
  const now = Date.now();
  // mwx.log.info(
  //   `beforeEach:to=${to.fullPath},from=${from.fullPath},time=${
  //     now - lastGoBackTime
  //   },to.name=${to.name}`
  // );
  Indicator.close();
  try {
    // 如果距离上次导航不足最小间隔，则阻止这次导航
    // console.log('now - lastGoBackTime', now - lastGoBackTime);
    // 限制以下路由短时间内导航多次
    if (
      now - lastGoBackTime < minNavigationInterval &&
      [ROUTE_NAMES.home, ROUTE_NAMES.orderDetail, ROUTE_NAMES.addPhoto].indexOf(
        to.name
      ) > -1
    ) {
      mwx.log.info('Too fast! Navigation blocked.');
      return next(false); // 阻止导航
    }

    // 更新最后一次导航时间
    lastGoBackTime = now;
    if (from.fullPath == '/') {
      // 刷新页面导致的重定向是允许多时间内导航多次的
      lastGoBackTime = 0;
    }
  } catch (error) {
    // console.error(error);
    // 处理错误
  }
  if (from.path == '/') {
    // 中间过程流程的页面手动刷新之后，需要回到首页
    let token = mwx.getToken();
    //

    // 检查是否是返回操作

    let mustLogin = true;
    // mustLogin = false;
    let notLoginWhiteList = [
      ROUTE_NAMES.retouch,
      ROUTE_NAMES.test,
      ROUTE_NAMES.background,
      ROUTE_NAMES.demo
    ];

    let isFromMiniApp =
      location.href.indexOf('wxData') > -1 &&
      location.href.indexOf('token') > -1;
    if (isFromMiniApp) {
      mustLogin = false;
    }

    if (
      ([ROUTE_NAMES.createCard, ROUTE_NAMES.saveImage].indexOf(to.name) > -1 ||
        (!token && to.name != ROUTE_NAMES.home)) &&
      mustLogin &&
      notLoginWhiteList.indexOf(to.name) == -1
    ) {
      if (!token && to.name != ROUTE_NAMES.home && to.query.soId) {
        let deviceId = Store.get('deviceId');
        if (!deviceId) {
          deviceId = mwx.createId(32);
          Store.set('deviceId', deviceId);
        }
        mwx.api
          .siteVisitorLogin({ deviceId, soId: to.query.soId })
          .then((r) => {
            mwx.setToken(r.token);
            // 登录接口返回业务 uid 时，同步给 Sentry Logs 的用户维度。
            if (r.uid) {
              Store.set('__uid', r.uid);
              mwx.setSentryUser({ userId: r.uid });
            }
            next();
            window.report &&
              window.report('error', {
                reason: 'router location.reload1'
              });
            location.href = location.origin;
          })
          .catch((err) => {
            next(false);
            window.report &&
              window.report('error', {
                reason: 'router location.reload2'
              });
            location.href = location.origin;
          });
        return;
      }
      mwx.log.error(
        `重定向到首页,to=${JSON.stringify(to)},from=${JSON.stringify(from)}`
      );
      next(false);
      window.report &&
        window.report('error', {
          reason: 'router location.reload3'
        });
      location.href = location.origin;

      return;
    } else {
      next();
    }
  } else {
    next();
  }
});

router.onError((error) => {
  // mwx.log.error(error);
});

// keep-alive缓存的路由列表
const keepAliveRouteList = [
  ROUTE_NAMES.createCard,
  ROUTE_NAMES.saveImage,
  ROUTE_NAMES.selectCard,
  ROUTE_NAMES.addPhoto,
  ROUTE_NAMES.selectTemplate,
  ROUTE_NAMES.chooseTemplate,
  ROUTE_NAMES.editPaster,
  ROUTE_NAMES.edit,
  ROUTE_NAMES.editImageNew,
  ROUTE_NAMES.editPhotoRoll,
  ROUTE_NAMES.editWhiteInk,
  ROUTE_NAMES.editWhiteInkNew,
  ROUTE_NAMES.editColorPaper
];

function getKeepAliveRouteList({ to, from }) {
  let includeList;
  if (
    to.name == ROUTE_NAMES.cardDetail &&
    from.name == ROUTE_NAMES.createCard
  ) {
    includeList = [
      ROUTE_NAMES.cardDetail,
      ...keepAliveRouteList.filter((v) => v !== ROUTE_NAMES.createCard)
    ];
  } else {
    includeList = [ROUTE_NAMES.cardDetail, ...keepAliveRouteList];
  }
  if (
    to.name == ROUTE_NAMES.editPaster &&
    from.name == ROUTE_NAMES.editWhiteInk
  ) {
    // 不缓存
    includeList = includeList.filter((v) => v != ROUTE_NAMES.editWhiteInk);
  }
  if (to.name == ROUTE_NAMES.edit && from.name == ROUTE_NAMES.editWhiteInkNew) {
    // 不缓存
    includeList = includeList.filter((v) => v != ROUTE_NAMES.editWhiteInkNew);
  }
  if (
    to.name == ROUTE_NAMES.edit &&
    from.name == ROUTE_NAMES.reversePrimerLayer
  ) {
    // 不缓存
    includeList = includeList.filter(
      (v) => v != ROUTE_NAMES.reversePrimerLayer
    );
  }
  if (to.name == ROUTE_NAMES.edit && from.name == ROUTE_NAMES.editScopeUv) {
    // 不缓存
    includeList = includeList.filter((v) => v != ROUTE_NAMES.editScopeUv);
  }
  if (to.name == ROUTE_NAMES.edit && from.name == ROUTE_NAMES.editImageNew) {
    // 从 editImageNew 返回 edit 时释放缓存，避免下次进入沿用旧编辑态。
    includeList = includeList.filter((v) => v != ROUTE_NAMES.editImageNew);
  }
  return includeList;
}

export { router, keepAliveRouteList, getKeepAliveRouteList, ROUTE_NAMES };
